export enum PromoGrantTypeEnum {
  PROMO_GRANT_TYPE_ALL = "all",
  PROMO_GRANT_TYPE_HIGHEST_TIER = "highest_tier",
}

export default PromoGrantTypeEnum;
